import React, {forwardRef, Key} from 'react';

import {ModalOpenerComponent, IModalOpenerComponentRef} from 'components/modal-opener-component';
import {TStateSetter} from 'shared/types/generics';
import {showMessage} from 'shared/utils';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {removeAisDocumentsInRegister} from 'store/slices/ais-slice/ais-slice-thunks';
import {selectIsThunkPending} from 'store/slices/loading-state-slice';

interface IDeleteConfirmationModalProps {
    selectedRowKeys: Key[];
    setSelectedRowKeys: TStateSetter<Key[]>;
    handleRefresh: () => void;
}

export const DeleteConfirmationModal = forwardRef<IModalOpenerComponentRef, IDeleteConfirmationModalProps>((
    {selectedRowKeys, handleRefresh, setSelectedRowKeys}: IDeleteConfirmationModalProps,
    ref,
) => {
    const dispatch = useAppDispatch();

    const isDeleting = useAppSelector(s => selectIsThunkPending(s, removeAisDocumentsInRegister.typePrefix));

    const handleDelete = (setIsModalOpen: TStateSetter<boolean>) => {
        dispatch(removeAisDocumentsInRegister({
            ids: selectedRowKeys as number[],
        })).unwrap().then(() => {
            showMessage({message: 'Записи успешно удалены'});
            setSelectedRowKeys([]);
            setIsModalOpen(false);
            handleRefresh();
        }, () => {
            showMessage({message: 'Во время удаления записей произошла ошибка', isError: true});
        });
    };

    return (
        <ModalOpenerComponent
            ref={ref}
            modalProps={{
                forceRender: false,
                destroyOnClose: true,
                title: 'Подтверждение',
                centered: true,
            }}
            controlLabels={{
                save: 'Удалить',
            }}
            loadingControls={{
                save: isDeleting,
            }}
            disabledControls={{
                save: isDeleting,
            }}
            handleSave={setIsModalOpen => {
                handleDelete(setIsModalOpen);
            }}
        >
            Вы действительно хотите удалить выбранные записи?
        </ModalOpenerComponent>
    );
});
